import React, { useEffect, useState } from 'react'
import SideMenu from '../../../../Components/SideDrawer';
import { Container, Dropdown, Form, Row, Col, Button, Table } from 'react-bootstrap';


import PageHeader from '../../../../Components/Header';
import { companyGet, employeeGet, employeePayRangeDetails } from '../../../../Api/Admin/AdminApi';
import { extractErrorMessage } from '../../../../Utils/ErrorUtlis';

const PaySheetReport = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeData, setEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPayLoading, setIsPayLoading] = useState(false);
  const initialData = {
    startDate: '',
    endDate: '',
    emp_id: ''
  };
  const [formData, setFormData] = useState(initialData);


  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(true)
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, [])

  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          team: i.team,
          team_id: i.team_id
        }));
        setEmployeeData(emp)
        // getTeam();
        setIsLoading(false)
      } else {
        setIsLoading(true)
      }

    } catch (err) {
      setIsLoading(true)
      const errorMessage = extractErrorMessage(err);
      console.log('Error Fetching Employee data', errorMessage || err);
      alert(errorMessage);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'emp_id') {
      const selectedEmployee = employeeData.find(emp => emp.emp_id === value);
      if (selectedEmployee) {
        setFormData(prev => ({
          ...prev,
          [name]: value,
          team_id: selectedEmployee.team_id // Auto-set the team_id
        }));
        setSelectedEmployee(value);
        return;
      }
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    console.log(`${name}: ${value}`);
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await employeePayRangeDetails(formData)
      if (response.results) {
        const dateRangePaysheet = response.results.map(i => ({
          _id: i._id,
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          company: i.company,
          Design: i.Design,
          total_working_days: i.total_working_days,
          total_overtime_hours: i.total_overtime_hours,
          pay_month: i.pay_month,
          basic_pay: i.basic_pay,
          attendance_allowence: i.attendance_allowence,
          overtime_pay: i.overtime_pay,
          standard_gross: i.standard_gross,
          allowences: i.allowences,
          incentives: i.incentives,
          lop: i.lop,
          earned_gross: i.earned_gross,
          CPF: i.CPF,
          advances: i.advances,
          other: i.other,
          netpay: i.netpay,
        }));
        setApiData(dateRangePaysheet);
        setIsPayLoading(true);
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err);
      console.log('Error in Getting Paysheet Report ', errorMessage || err);
      alert(errorMessage);
    }
    setFormData(initialData)
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title="Employee Paysheet Report " showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Paysheet Report
          <Dropdown onSelect={(eventKey) => {
            const selected = organizations.find(c => c.id == String(eventKey));
            let callID = selected.id;
            setSelectedCompany(selected);
            onEmployeedetails(callID);
          }}>
            <Dropdown.Toggle variant="outline-secondary" id="company-dropdown">
              {selectedCompany ? selectedCompany.name : "Select Company"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {!loadingCompany ? (
                <Dropdown.Item disabled>Loading...</Dropdown.Item>
              ) : (
                organizations.map(com => (
                  <Dropdown.Item key={com.id} eventKey={com.id} active={selectedCompany?.id === com.id}>
                    {com.name}
                  </Dropdown.Item>
                ))
              )}
            </Dropdown.Menu>
          </Dropdown>
        </h4>
        <Form onSubmit={handleSubmit} className='mt-4'>
          <Row className='mb-3'>
            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Employee Name</Form.Label>
              <Form.Select
                name='emp_id'
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Employee</option>
                {employeeData.map(empl => (
                  <option key={empl.emp_id} value={empl.emp_id}>{empl.emp_name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId='startDate'>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type='date'
                name='startDate'
                value={formData.startDate}
                onChange={handleDateChange}
                required
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId='endDate'>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type='date'
                name='endDate'
                value={formData.endDate}
                onChange={handleDateChange}
                required
              >
              </Form.Control>
            </Form.Group>
          </Row>
          <Row className="mb-3 justify-content-center">
            <Form.Group as={Col} md='4' className="text-center">
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px', height: '30px' }}>
                Get Report
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {!isPayLoading ? '': <div>
          <Row>
            <h6>Employee Name:{employeeData.find(emp => emp.emp_id === selectedEmployee)?.emp_name}</h6>
            <h6>Company Name: {selectedCompany?.name}</h6>
            {/* <h6>Desigination:</h6> */}
          </Row>
        </div>}
        {!isPayLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div tyle={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Working Days</th>
                <th className="fs-12">Overtime Hours</th>
                <th className="fs-12">Pay Month</th>
                <th className="fs-12">Basic Pay</th>
                <th className="fs-12">Attendance Allowence</th>
                <th className="fs-12">Overtime Pay</th>
                <th className="fs-12">Standard Cross</th>
                <th className="fs-12">Allowence</th>
                <th className="fs-12">Incentives</th>
                <th className="fs-12">Loss of Pay</th>
                <th className="fs-12">Earned Cross</th>
                <th className="fs-12">CPF</th>
                <th className="fs-12">Advances</th>
                <th className="fs-12">Other</th>
                <th className="fs-12">Net Pay</th>

              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.total_working_days}
                  </td>
                  <td className="fs-12">
                    {emp.total_overtime_hours}
                  </td>
                  <td className="fs-12">
                    {emp.pay_month}
                  </td>
                  <td className="fs-12">
                    {emp.basic_pay}
                  </td>
                  <td className="fs-12">
                    {emp.attendance_allowence}
                  </td>
                  <td className="fs-12">
                    {emp.overtime_pay}
                  </td>
                  <td className="fs-12">
                    {emp.standard_gross}
                  </td>
                  <td className="fs-12">
                    {emp.allowences}
                  </td>
                  <td className="fs-12">
                    {emp.incentives}
                  </td>
                  <td className="fs-12">
                    {emp.lop}
                  </td>
                  <td className="fs-12">
                    {emp.earned_gross}
                  </td>
                  <td className="fs-12">
                    {emp.CPF}
                  </td>
                  <td className="fs-12">
                    {emp.advances}
                  </td>
                  <td className="fs-12">
                    {emp.other}
                  </td>
                  <td className="fs-12">
                    {emp.netpay}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
      </Container>
    </div>
  );
}

export default PaySheetReport